import { toast, Slide } from 'react-toastify';

export const scrollToId = (id, offset = 0) => {
	const element = document.getElementById(id);
	if (element) {
		const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
		const offsetPosition = elementPosition + offset;

		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth"
		});
	}
};

export const navigateToSection = (sectionId, navigate, location, offset = 0) => {
	if (location.pathname !== '/') {
		navigate('/');
		setTimeout(() => scrollToId(sectionId, offset), 100);
	} else {
		scrollToId(sectionId, offset);
	}
};

export const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

export const notify = (message, type = 'success') => {
    const config = {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
    }
    switch (type) {
        case 'success':
            toast.success(message, config);
            break;
        case 'warning':
            toast.warning(message, config);
            break;
        case 'info':
            toast.info(message, config);
            break;
        default:
            toast.error(message, config);
            break;
    }
};